module.exports = __webpack_public_path__ + "static/media/how_to_use_6.9beb37aa.png";